var map = {
	"./account.json": 77887,
	"./applyRefund.json": 19314,
	"./brand.json": 88945,
	"./common.json": 197,
	"./commonHomeChannel.json": 78257,
	"./footer.json": 65611,
	"./home.json": 14871,
	"./luckseller.json": 76662,
	"./msg.json": 53213,
	"./order.json": 62680,
	"./payment.json": 27346,
	"./prod.json": 97065,
	"./refundDetail.json": 64747,
	"./register.json": 81181,
	"./returnLogistics.json": 13789,
	"./shopline.json": 59002,
	"./uploadFile.json": 22759
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9514;